import * as React from 'react';
export const IcFindInPage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.01 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9.11-7.12C20.56 3.32 19.79 3 19 3H5c-.8 0-1.56.32-2.12.88S2 5.21 2 6v12c0 .8.32 1.56.88 2.12S4.21 21 5 21h14c.8 0 1.56-.32 2.12-.88S22 18.79 22 18V6c0-.8-.32-1.56-.88-2.12zM10.29 5.29A.99.99 0 0111 5a1.014 1.014 0 01.99 1.2c-.04.2-.13.37-.27.51s-.32.24-.51.27a1.014 1.014 0 01-1.2-.99c0-.27.11-.52.29-.71l-.01.01zm-4.31.9c-.04.19-.13.37-.27.51s-.32.24-.51.27A1.014 1.014 0 014 5.98c0-.27.11-.52.29-.71A.99.99 0 015 4.98c.2 0 .39.06.56.17.16.11.29.27.37.45.08.18.1.38.06.58l-.01.01zm1.64.73A1.014 1.014 0 017 5.99c0-.27.11-.52.29-.71A.99.99 0 018 4.99a1.014 1.014 0 01.99 1.2c-.04.2-.13.37-.27.51s-.32.24-.51.27c-.19.04-.4.02-.58-.06l-.01.01zm10.1 11.79c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29l-2.27-2.27c-.59.35-1.28.57-2.02.57-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .74-.22 1.42-.57 2.02l2.27 2.27c.39.39.39 1.02 0 1.41h.01z'
      fill='currentColor'
    />
  </svg>
);
